import { useAccount } from "wagmi"

export const useGianoAccount = () => {
    return useAccount()
}